import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import PublicHome from "@/pages/PublicHome";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CollageWorkflow from "@/pages/CollageWorkflow";
import PassportWorkflow from "@/pages/PassportWorkflow";
import PosCalculator from "@/pages/pos/PosCalculator";
import PosDashboard from "@/pages/pos/PosDashboard";
import PosHistory from "@/pages/pos/PosHistory";

function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex items-center gap-3 text-slate-500">
          <div className="w-3 h-3 rounded-full bg-[#299fe0] animate-pulse" />
          <span className="font-sans text-sm">Checking session…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/collage"
            element={
              <ProtectedRoute>
                <CollageWorkflow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/passport"
            element={
              <ProtectedRoute>
                <PassportWorkflow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/pos"
            element={
              <ProtectedRoute>
                <PosCalculator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/pos/dashboard"
            element={
              <ProtectedRoute>
                <PosDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/pos/history"
            element={
              <ProtectedRoute>
                <PosHistory />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: { fontFamily: "Manrope, sans-serif", borderRadius: "12px" },
        }}
      />
    </AuthProvider>
  );
}

export default App;
